module.exports = __webpack_public_path__ + "img/gpktwob_packs.topps.61a14d0.png";